export const dateToTimestamp = (date) => {
  try {
    return new Date(date).getTime() / 1000;
  } catch {
    return null;
  }
};

export const timestampToDate = (timestamp) => {
  let date = new Date(timestamp * 1000);

  var dd = String(date.getDate()).padStart(2, "0");
  var mm = String(date.getMonth() + 1).padStart(2, "0"); //January is 0!
  var yyyy = date.getFullYear();

  return `${yyyy}-${mm}-${dd}`;
};


export const camelizeStr = (str) => {
  return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
    if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
    return index === 0 ? match.toLowerCase() : match.toUpperCase();
  });
};

export const updateQueryStringParameter = (uri, key, value) => {
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf('?') !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + "=" + value + '$2');
  }
  else {
    return uri + separator + key + "=" + value;
  }
}

export const getDomainFromURL = (url) => {
  const domain = (new URL(url)).hostname;
  return domain;
}

export const getFormattedPostDateTime = (postDateTime) => {
  let msPerMinute = 60 * 1000;
  let msPerHour = msPerMinute * 60;
  let msPerDay = msPerHour * 24;

  let postDate = new Date(postDateTime * 1000);
  let now = Date.now();

  let elapsed = now - postDate;
  let elapsed_text = null


  if (elapsed < msPerMinute) {
    elapsed_text = (elapsed / 1000 | 0) + ' seconds ago';
  }
  else if (elapsed < msPerHour) {
    elapsed_text = (elapsed / msPerMinute | 0) + ' minutes ago';
  }
  else if (elapsed < msPerDay) {
    elapsed_text = (elapsed / msPerHour | 0) + ' hours ago';
  }
  else if (elapsed < 8 * msPerDay) {
    let days = elapsed / msPerDay | 0;
    if (days == 1)
      elapsed_text = 'Yesterday';
    else {
      elapsed_text = days + ' days ago';
    }
  }
  else {
    var options = { year: 'numeric', month: 'long', day: 'numeric' };
    elapsed_text = postDate.toLocaleDateString('en-US', options);

  }

  return elapsed_text
}



export const convertNumberToKiloNotation = (num) => {
  return Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'k' : Math.sign(num) * Math.abs(num);

}

export const converYoutubeLinkToEmbedLink = (normalLink) => {
  // Problem : to play a youtube link in embedded player the url should contain "embed" 
  // Example https://youtu.be/3sPHQzY48RE --(converted to )-> https://www.youtube.com/embed/3sPHQzY48RE
  var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = normalLink.match(regExp);
  var videoID = (match && match[7].length == 11) ? match[7] : false;

  return "https://www.youtube.com/embed/" + videoID;
}

export const convertMilliSecondsToIsoFormat = (milliSeconds) => {
  var isoFormat = null;
  if (milliSeconds < 3600) {
    isoFormat = new Date(milliSeconds * 1000)
      .toISOString()
      .substr(14, 5);
  } else {
    isoFormat = new Date(milliSeconds * 1000)
      .toISOString()
      .substr(11, 8);
  }

  return isoFormat;

}

export const converYoutubeShortsLinkToEmbedLink = (ytShortsLink) => {
  const regex = /\/shorts\/([^/?#]+)(?:[/?#]|$)/;
  const match = ytShortsLink.match(regex);

  if (match) {
      const lastPart = match[1];
      return "https://www.youtube.com/embed/" + lastPart;
  } else {
      return false;
  }
}

export const converYoutubeLiveLinkToEmbedLink = (ytShortsLink) => {
  const regex = /\/live\/([^/?#]+[/?#].*)$/;
  const match = ytShortsLink.match(regex);

  if (match) {
      const lastPart = match[1];
      return "https://www.youtube.com/embed/" + lastPart;
  } else {
      return false;
  }
}

export const converDefaultYoutubeLinkToEmbedLink = (ytShortsLink) => { // UHV-26497
  const regex = /(?:youtu\.be\/|youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/;
  const match = ytShortsLink.match(regex);

  if (match) {
      const lastPart = match[1];
      return "https://www.youtube.com/embed/" + lastPart;
  } else {
      return false;
  }
}

export const getYoutubeThumbURL = (ytLink) => {
  let isShort = ytLink.toLowerCase().includes("shorts");
  let isLive = ytLink.toLowerCase().includes("live");
  let regex;

  switch (true) {
    case isShort:
      regex = /\/shorts\/([^/?#]+)(?:[/?#]|$)/;
      break;

    case isLive:
      regex = /\/(?:[^/?#]+\/)*([^/?#]+)(?:[/?#]|$)/;
      break;

    case !isShort && !isLive:
      regex = /\/(?:[^/?#]+\/)*([^/?#]+)(?:[/?#]|$)/;
      break;

    default:
      regex = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      break;
  }

  const match = ytLink.match(regex);
  if (match) {
      const videoId = match ? match[1] : null;
      return `https://img.youtube.com/vi/${videoId}/0.jpg`;
  } else {
      return false;
  }
}